import "./Home.module.css";
import Navigering from "@/reusable_sections/Header";
import WelcomeToTheLight from "./sections/WelcomeToTheLight";
import Hero from "./sections/Hero";
import CustomerTrust from "./sections/CustomerTrust";
import SpecialistAreas from "./sections/SpecialistAreas";
import CertifiedSecuritySince2010 from "./sections/CertifiedSecuritySince2010";
import OurEnvironmentalResponsibility from "./sections/OurEnvironmentalResponsibility";
import IndustryVoices from "./sections/IndustryVoices";
import BokaDinTid from "./sections/BokaDinTid";
import SidfotInfo from "@/reusable_sections/Footer";
import SwissStyleTextSection from "./sections/SwissStyleTextSection";
export default function HomePage() {
  return <div>
      <Navigering />
      <Hero />
      <WelcomeToTheLight />
      <SpecialistAreas />
      <CertifiedSecuritySince2010 />
      <SwissStyleTextSection />
      <OurEnvironmentalResponsibility />
      <CustomerTrust />
      <IndustryVoices />
      <BokaDinTid />
      <SidfotInfo />
    </div>;
}